<template>
	<div class="">
		<div class="aihao" id="aihao"></div>
	</div>
</template>

<script>
	export default {
		name: "",
		components: {

		},
		data() {
			return {}
		},
		mounted() {
			var myChart = this.$echarts.init(document.getElementById('aihao'));
			var option = {
				backgroundColor: '#fff',
				grid: {
					top: '5%',
					right: '6%',
					left: '6%',
					bottom: '10%'
				},
				xAxis: [{
					type: 'category',
					color: '#59588D',
					data: ['生物', '物理', '政治', '地理', '历史', '化学', '不限'],
					axisLabel: {
						margin: 10,
						color: '#666',
						textStyle: {
							fontSize: 16
						},
					},
					axisLine: {
						lineStyle: {
							color: 'rgba(107,107,107,0.37)',
						}
					},
					axisTick: {
						show: false
					},
				}],
				yAxis: [{
					axisLabel: {
						formatter: '{value}%',
						
						color: '#666',
						textStyle: {
							fontSize: 16
						},
					},
					axisLine: {
						lineStyle: {
			 			color: 'rgba(107,107,107,0.37)',
						}
					},
					axisTick: {
						show: false
					},
					splitLine: {
						lineStyle: {
							color: 'rgba(131,101,101,0.2)',
							type: 'dashed',
						}
					}
				}],
				series: [{
					type: 'bar',
					data: [45, 78, 35, 70, 34, 46, 90],

					barWidth: '50px',
					itemStyle: {
						normal: {
							color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: '#29A7E1' },
									{ offset: 1, color: '#ffffff00' }
								]),
							barBorderRadius: [5, 5, 0, 0]
						},
					},
					label: {
						normal: {
							show: true,
							formatter: "{c}%",
							fontSize: 16,
							color: '#29A7E1',
							position: 'top',
						}
					}
				}, ]
			};
			// 使用刚指定的配置项和数据显示图表。
			myChart.setOption(option);
		},
		methods: {

		}


	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/tubiao/cepingjieguo2.vue